import { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'
import type { Product } from '@/shared/types'

export type RestockLine = {
  product: Product
  qty: number
  costOverride?: number
}

const CODE_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

export function generateRestockCode(): string {
  return Array.from(
    { length: 6 },
    () => CODE_CHARS[Math.floor(Math.random() * CODE_CHARS.length)]
  ).join('')
}

type RestockContextValue = {
  lines: RestockLine[]
  setLines: React.Dispatch<React.SetStateAction<RestockLine[]>>
  restockCode: string
  spentRaw: string
  setSpentRaw: React.Dispatch<React.SetStateAction<string>>
  resetRestock: () => void
}

const RestockContext = createContext<RestockContextValue | null>(null)

export function RestockProvider({ children }: { children: ReactNode }) {
  const [lines, setLines] = useState<RestockLine[]>([])
  const [restockCode, setRestockCode] = useState(generateRestockCode)
  const [spentRaw, setSpentRaw] = useState('')

  function resetRestock() {
    setLines([])
    setSpentRaw('')
    setRestockCode(generateRestockCode())
  }

  return (
    <RestockContext.Provider value={{ lines, setLines, restockCode, spentRaw, setSpentRaw, resetRestock }}>
      {children}
    </RestockContext.Provider>
  )
}

export function useRestockContext() {
  const ctx = useContext(RestockContext)
  if (!ctx) throw new Error('useRestockContext must be used within RestockProvider')
  return ctx
}
